import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.XeroAmaxPayBatchPaymentStartStep', {
    bubbleText: 'Batch Payment Creation',
    title: 'Requesters can combine Bills approved in ApprovalMax into batch payment, add required payment data, and submit the batch payment for approval.',
    paymentCreation: 'Payment creation',
    description: 'Add users authorised to create Batch Payments and submit them for approval in ApprovalMax.',
});
